<template>
    <section class="userSteps">
        <Header />
        <div class="ContentBlock">
            <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
                <button type="button" class="close_btn">
                    <vue-feather size="26" type="x"></vue-feather>
                </button>
            </div>
            <div class="messageBlock" v-if="store.error.msg">
                <p class="alert" :class="(store.error.type == 'error') ? 'alert-danger' : 'alert-success'">{{store.error.msg}}</p>
            </div>
            <Form @submit="verifyOTP" class="inputForm text-center">
                <div class="mainTitle mb-md-5 mb-4">
                    <h3 class="text-center mb-3">{{$t('get_otp.text1')}}</h3>
                    <p class="mb-2" v-if="Object.keys(store.customerDetail).length > 0">{{$t('get_otp.text2')}}<strong v-if="store.customerDetail.email">{{store.customerDetail.email}}</strong></p>
                    <p>{{$t('get_otp.text3')}}</p>
                </div>

                <div class="d-flex flex-direction-row justify-content-center mb-4" >
                    <v-otp-input separator="" input-classes="otp-input" ref="otp_input"  
                        input-type="number" :num-inputs="6" :shouldAutoFocus="true" @on-change="handleOnChange" 
                        @on-complete="handleOnComplete" />
                    <Field  v-if="resetOtpStatus" style="display: none;" class="form-control" name="otp" placeholder="" v-model="form.code" :rules="required" />
                </div>
                <ErrorMessage name="otp" class="text-danger" />
                <span v-if="showCodeLengthError"  class="text-danger">Invalid OTP</span>

                <div class="form-group text-center mb-5" v-if="Object.keys(store.customerDetail).length > 0">
                    <a href="javascript:void(0)" class="underline link semibold" @click="resendOTP()">{{$t('get_otp.text4')}}</a>
                </div>
                <!-- <label class="customCheckBox line-4 mb-4">
                    {{$t('get_otp.text5')}}<a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}terms-of-service`">{{$t('get_otp.text6')}}</a>,
                    <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}privacy-policy`">{{$t('get_otp.text7')}}</a>,
                    <a class="semibold underline" :href="`${static_vars.domainURL}conflict-of-interest-policy`" target="_blank">{{$t('get_otp.text8')}}</a>,
                    <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}declaration-of-consent`">{{$t('get_otp.text9')}}</a>{{$t('get_otp.text10')}}
                    <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}risk-disclaimer`">{{$t('get_otp.text11')}}</a>
                    <input type="checkbox" v-model="form.terms" />
                    <Field type="hidden" name="Terms" rules="required" v-if="!form.terms" />
                    <span class="checkmark"></span>
                </label>
                <ErrorMessage name="Terms" class="text-danger" /> -->
                <div class="buttonElement mb-3">
                    <button type="submit" class="grd_btn full_size" v-if="!store.singleLoading" :class="(!captchaToken)?'disabled':''">{{$t('get_otp.text12')}}</button>
                    <button type="submit" class="grd_btn full_size" v-else><i class="me-2 fa fa-spinner fa-spin"></i>{{$t('get_otp.text13')}}</button>
                </div>
               <!--  <div class="otherLogin text-center">
                    <p class="medium d-flex align-items-center justify-content-center">
                        Didn’t receive code? <a href="javascript:void(0)" class="underline link semibold" @click="resendOTP()">Resend code</a> <vue-feather size="14" class="ms-1" type="alert-circle"></vue-feather>
                    </p>
                </div> -->
            </Form>
        </div>
        <stepFooter />
    </section>
</template>

<script>
    import { useMainStore } from "@/store";
    import stepFooter from "../../components/shared/step_footer";
    import { Form, Field, ErrorMessage } from "vee-validate";
    import { load } from "recaptcha-v3";
    import $ from 'jquery'
    import { useToast } from 'vue-toastification'
    const toast = useToast();
    export default {
        setup() {
            const store = useMainStore();
            const Crypto = require("crypto-js")
            return { store,Crypto }; //Crypto
        },
        data() {
            return {
                captchaToken: "",
                form: {
                    code: "",
                    // terms: false,
                },
                resetOtpStatus:true,              //for removing error message in case of resend OTP// to refresh the otp field
                showDemoAccountProcessing:false,
                showCodeLengthError:false
            };
        },
        computed: {
            isActive() {
                return false;
            },
        },
        watch:{
            'form.code'(){
                if(this.form.code == ''){
                    this.showCodeLengthError=false;
                }
            }
        },
        components: {
            stepFooter,
            Form,
            Field,
            ErrorMessage
        },
        methods: {
            CretioFunc() {
                try {
                    window.gtag("event", "test_verify");
                    window.fbq('trackCustom', 'email_verify', {'email' : this.store.userAccoutDetail?.email,'value' : '20','country' : this.store.flavorData?.userCountry?.name },{'eventID': `${this.store.userAccoutDetail?.id}_email_verify`});


                    // window.fbq('track', 'LEAD', {'email' : this.store.userAccoutDetail?.email,'value' : '20','country' : this.store.flavorData?.userCountry?.name },{'eventID': `${this.store.userAccoutDetail?.id}_email_verify`});


                    // console.log(window.fbq,'test',['trackCustom', 'email_verify', {'email' : this.store.userAccoutDetail?.email,'value' : '20','country' : this.store.flavorData?.userCountry?.name },{'eventID': `${this.store.userAccoutDetail?.id}_email_verify`}])
                    if (Object.keys(this.store.flavorData).length && this.store.flavorData.userCountry && Object.keys(this.store.flavorData.userCountry).length && this.store.flavorData.userCountry.isoCode) {
                        for (var key in this.static_vars.cretioCountryJson) {
                            if (key == this.store.flavorData.userCountry.isoCode) {
                                var s = document.createElement("script");
                                s.type = "text/javascript";
                                s.async = true;
                                s.src = `//dynamic.criteo.com/js/ld/ld.js?a=${this.static_vars.cretioCountryJson[key]}`;
                                $("head").append(s);
                                window.criteo_q = window.criteo_q || [];
                                var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                                window.criteo_q.push(
                                    { event: "setaccount", account: this.static_vars.cretioCountryJson[key]}, // You should never update this line
                                     { event: "setSiteType", type: deviceType},
                                     //{ event: "setemail", email: this.Crypto.SHA256(this.store.customerDetail.email).toString() , hash_method: "sha256" }, 
                                      { event: "setemail", email: this.Crypto.SHA256('1').toString() , hash_method: "sha256" },
                                        { event: "trackTransaction", id: (Math.random() * 50000), item: [
                                            {id : Math.ceil(Math.random()*10300 * Math.random() * 50000), price:1, quality : 1}
                                        ]}
                                );
                            }
                        }
                    }
                } catch (e) {
                    console.log("cretio ex", e);
                }
            },
            reset() {
                this.form.code = "";
            },
            handleOnComplete(value) {
                this.form.code = value;
            },
            handleOnChange(value) {
                this.form.code = value;
            },
       

            resendOTP() {
                let _that = this;
                this.showCodeLengthError = false;
                this.resetOtpStatus = false;
                setTimeout(function(){
                    _that.resetOtpStatus = true;
                },50);
                this.form.code ='';
                this.$refs.otp_input.clearInput();
                load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                    recaptcha.execute("login").then((token) => {
                        // console.log(token) // Will print the token
                        this.captchaToken = token;
                        if (this.captchaToken) {
                            this.reset();
                            let formData = {};
                            formData["identifier"] = "EMAIL";
                            formData["email"] = this.store.customerDetail.email;
                            if (this.captchaToken) {
                                formData["captcha"] = {};
                                formData["captcha"]["response"] = this.captchaToken;
                            }
                            this.store.resendOTP(formData, true);
                        }
                    });
                });
            },
            verifyOTP() {
                let _that = this;
                if(this.form.code.length < 6){
                    this.showCodeLengthError = true;
                    return;
                }

                load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                    recaptcha.execute("login").then((token) => {
                        // console.log(token) // Will print the token
                        this.captchaToken = token;
                        if (this.captchaToken) {
                            let formData = {};
                            formData["code"] = this.form.code;
                            formData["email"] = this.store.customerDetail.email;
                            if (this.captchaToken) {
                                formData["captcha"] = {};
                                formData["captcha"]["response"] = this.captchaToken;
                            }
                            this.store.verifyOTP(formData, true, this).then((response) => {
                                let data = this.store.customerDetail;
                                data.emailVerified = true;
                                this.store.$patch({ customerDetail: data })
                                return response;
                            })
                            // .then(function(){
                            //     _that.store.callCustomerDetail({},false,this)
                            // })
                            .then(function(response){
                                if(response == true){
                                    let demo_account = false;
                                    if (typeof _that.store.userTradingAccountsList !== 'undefined' && _that.store.userTradingAccountsList !== null) {
                                        Object.keys(_that.store.userTradingAccountsList).forEach(function(acc){
                                            if(_that.store.userTradingAccountsList[acc].demo == true){
                                                demo_account = true;
                                            } 
                                        });
                                    }
                                    if(demo_account == false){
                                        _that.$router.replace('/demo-acc');
                                        // _that.showDemoAccountProcessing = true;
                                        // setTimeout(function(){
                                        //     _that.store.createDemoAccount()
                                        //     .then(function(){
                                        //         _that.showDemoAccountProcessing = false;
                                        //         _that.refreshToken();
                                        //         toast.success('Demo account has been created!');
                                        //     })
                                        //     .then(function(){
                                        //         setTimeout(function(){
                                        //             _that.$router.replace('/complete-registration');
                                        //         },1000);
                                        //     });
                                        // },2000);
                                        
                                    } 
                                }
                                else{
                                    toast.error(_that.$t('view_login.text12'));
                                }
                            })
                            .catch(function(error){
                                console.log(error)
                            });
                        }
                    })
                   
                });
            },

        //   refreshToken:function(){
        //         let form = {
        //             'grant_type' : 'refresh_token',
        //             'refresh_token' : this.store.user.refresh_token
        //         };
        //         this.store.refreshToken(form,false,'basic').then((response) =>{
        //             if(response.access_token){
        //                 this.store.getUserAccountsList({},false)
        //             }
        //         })
        //     },
        },
        mounted() {
            load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                recaptcha.execute("login").then((token) => {
                    // console.log(token) // Will print the token
                    this.captchaToken = token;
                });
            });
        },
    };
</script>
